import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { tableDataContext } from "../dashboard/context/productData";
import UserNavbar from "./userNavbar";
import UserFooter from "./userFooter";
import GridSection from "./GridSection";

const UserDashboard = () => {
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");
  const [favorites, setFavorites] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [holdData, setHoldData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [holdDataFilters, setHoldDataFilters] = useState([]);
  const [adminFiltered, setAdminFiltered] = useState([]);
  const { id } = useParams();
  const {
    setFullData,
    selectedFilters,
    setSelectedFilters,
    setFilters,
    filters,
    selectedVendor,
  } = useContext(tableDataContext);
  const [selectedTab, setSelectedTab] = useState("allProduct");

  useEffect(() => {
    handleSaveHistory();
    handleFavorites();
    setSelectedFilters([]);
  }, []);

  console.log(selectedFilters);

  useEffect(() => {
    handleTabData();
  }, [selectedTab]);

  const handleTabData = () => {
    if (selectedTab === "allProduct") {
      handleAllData();
    } else if (selectedTab === "myChains") {
      handleMyChains();
    } else if (selectedTab === "favorites") {
      handleFavorites();
    }
  };

  useEffect(() => {
    selectedSearch();
  }, [selectedFilters]);

  const handleChangeForSearch = (e) => {
    setError("");
    setSearch(e.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const selectedSearch = (e) => {
    if (selectedFilters.length === 0) {
      if (selectedTab === "allProduct") {
        handleAllData();
      } else if (selectedTab === "myChains") {
        handleMyChains();
      } else if (selectedTab === "favorites") {
        handleFavorites();
      }
    } else if (selectedTab === "favorites") {
      const filteredResults = holdDataFilters.filter((product) => {
        return selectedFilters.some((filter) => {
          return product.productName
            .toLowerCase()
            .includes(filter.toLowerCase());
        });
      });
      setHoldData(filteredResults);
    } else {
      if (selectedVendor && selectedVendor != "default") {
        const filteredData = adminFiltered.filter(
          (item) => item.vendorName === selectedVendor
        );
        const filteredResults = filteredData.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      } else {
        const filteredResults = adminFiltered.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      }
    }
  };

  const handleSaveHistory = async () => {
    try {
      axios
        .post("https://aipricingtool-python.onrender.com/get_saved_products", {
          user_identifier: id,
        })
        .then((response) => {
          setFilters(response.data);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const handleParseData = (res) => {
    // Build a map of expire_date by pdf_name, vendor_name, user_identifier
    const expireDateMap = {};
    res.forEach(item => {
      if (item.expire_date) {
        const key = `${item.pdf_name}_${item.vendor_name}_${item.user_identifier}`;
        expireDateMap[key] = item.expire_date;
      }
    });
    const data = res.filter((p) => p.output);
    const structuredData = data.flatMap((item) => {
      try {
        const products = JSON.parse(item.output.output);
        return products.map((product) => {
          const key = `${item.pdf_name}_${item.vendor_name}_${item.user_identifier}`;
          return {
            productName: product["Product Name"] || "",
            oldPrice: product["Old Price"] || "",
            currentPrice: product["Current Price"] || "",
            quantity: product["Quantity"] || "",
            discount: product["Discount"] || "",
            pdfName: item.pdf_name || "",
            vendorName: item.vendor_name || "",
            // expire_date: expireDateMap[key] || "Not Available",
            expire_date: item.expiry_date || "Not Available",
          };
        });
      } catch (error) {
        setLoader(false);
        console.error(
          `Error parsing JSON for item with pdf_name: ${item.pdf_name}`,
          error
        );
        return [];
      }
    });
    if (selectedVendor && selectedVendor != "default") {
      const filteredResults = structuredData.filter(
        (item) => item.vendorName === selectedVendor
      );
      setFullData(filteredResults);
    } else {
      setFullData(structuredData);
    }
    setAdminFiltered(structuredData);
    setLoader(false);
  };

  const handleMyChains = () => {
    setFullData([]);
    setLoader(true);
    axios
      .get(`https://aipricingtool-python.onrender.com/check_user_data/${id}`)
      .then((resp) => {
        handleParseData(resp.data);
      })
      .catch((err) => {
        setLoader(false);
        console.error(err);
      });
  };

  const handleDeleteHistory = () => {
    if (filters.length > 0) {
      axios
        .post("https://aipricingtool-python.onrender.com/delete_history", {
          user_identifier: id,
        })
        .then((res) => {
          toast.success(res.data.message);
          setSelectedFilters([]);
          setFilters([]);
          handleTabData();
        })
        .catch((err) => {
          console.error(err.response.data.error);
          toast.error(err.response.data.error);
        });
    }
  };

  const handleAllData = () => {
    setFullData([]);
    setLoader(true);
    axios
      .get(`${process.env.REACT_APP_API}/non_expired_products`)
      .then((res) => {
        handleParseData(res.data.non_expired_products);
      })
      .catch((err) => {
        console.error(err);
        setLoader(false);
      });
  };

  const handleFavorites = () => {
    axios
      .get(
        `https://aipricingtool-python.onrender.com/get_data_by_user_identifier/${id}`
      )
      .then((resp) => {
        if (resp.data.message) {
          setFavorites([]);
          setHoldData([]);
          setHoldDataFilters([]);
          setLoader(false);
          return;
        }
        const data = resp.data.map((product) => ({
          _id: product._id,
          productName: product.product_name,
          oldPrice: product.old_price || "",
          currentPrice: product.current_price || "",
          quantity: product.quantity || "",
          discount: product.discount || "",
          pdfName: product.pdf_name || "",
          vendorName: product.vendor_name || "",
          // expire_date: expireDateMap[key] || "Not Available",
          expire_date: product.expiry_date || "Not Available",
        }));
        setHoldData(data);
        setHoldDataFilters(data);

        const favorites = resp.data.map(
          (product) => `${product.product_name}-${product.vendor_name}`
        );

        setFavorites(favorites);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSearch = () => {
    try {
      if (!search) {
        return;
      }

      setFilters((prevFilters) => [...prevFilters, search]);
      if (!selectedFilters.includes(search)) {
        setSelectedFilters([...selectedFilters, search]);
      }
    } catch (error) {
      console.error("Error processing search:", error);
    }
  };

  return (
    <>
      <div className="flex flex-col">
        <UserNavbar />
        <div className="flex-1 pb-6 mt-16 mb-16">
          <div className="flex flex-col pt-4  font-userFont">
            <div className="bg-[#F7F7F7] w-full flex flex-col mb-4 items-center px-auto py-8 space-y-8">
              {/* Search Bar */}
              <div className="search_bar bg-searchbar setting lg:w-2/5 md:w-1/2 w-3/4 flex items-center px-5 py-4 gap-3 rounded-full">
                <input
                  type="text"
                  name="searchbar"
                  value={search}
                  onChange={handleChangeForSearch}
                  className="bg-white  w-full !border-0 placeholder-placeholderColor"
                  placeholder="Search Here......."
                  onKeyDown={handleKeyDown}
                />
                {search && (
                  <Icon
                    className="cursor-pointer"
                    onClick={() => {
                      if (selectedFilters.includes(search)) {
                        setSelectedFilters(
                          selectedFilters.filter((item) => item !== search)
                        );
                      }
                      setSearch("");
                    }}
                    icon="carbon:close-filled"
                    fontSize={25}
                    color="#E3D0A8"
                  />
                )}
                <Icon
                  icon="ri:search-line"
                  className="cursor-pointer"
                  color="#E3D0A8"
                  width="20"
                  height="20"
                  onClick={() => handleSearch()}
                />
              </div>
              {error && <p className="text-red-500 text-sm">{error}</p>}
            </div>

            <GridSection
              handleSaveHistory={handleSaveHistory}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              favorites={favorites}
              handleDeleteHistory={handleDeleteHistory}
              holdData={holdData}
              handleFavorites={handleFavorites}
              loader={loader}
              vendorData={adminFiltered}
            />
          </div>
        </div>

        <UserFooter />
      </div>
    </>
  );
};

export default UserDashboard;
